import { Box, Flex } from '@osmosis/tailwind-ui/components/Box';
import { H2, P } from '@osmosis/tailwind-ui/components/Text';
import React, { useState } from 'react';
import moment from 'moment';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import { Tooltip } from '@osmosis/tailwind-ui/components/tooltip/Tooltip';
import { Deal, PlansDealBannerProps, SchoolData } from '../../types/plans';
import { text0 } from '@osmosis/tailwind-ui/styles/text';

type Props = {
  plansPage: PlansDealBannerProps;
};

/**
 * ActiveDealBanner.
 */
const ActiveDealBanner: React.FC<Props> = ({ plansPage }): JSX.Element => {
  const { deal, schoolData, dealPaused, isUserDeal, friendName } = plansPage;
  const [subBanner, setSubBanner] = useState(false);

  const getCaption = (
    isUserDeal: boolean,
    friendName?: string,
    schoolData?: SchoolData,
    deal?: Deal,
  ) => {
    if (schoolData && schoolData.nickname)
      return 'Exclusive 10% off deal for ' + schoolData.nickname + ' students';
    if (isUserDeal && friendName) return 'Exclusive deal from ' + friendName;
    return deal?.caption || 'Osmosis Flash Deal!';
  };

  const getSubcaption = () => {
    if (schoolData) {
      const expires = moment().endOf('month').format('MMMM Do, YYYY');
      return `Don't miss out on this limited time offer! This offer ends ${expires}.`;
    }
    if (isUserDeal)
      return deal?.msg || "Don't miss out on this limited time offer!";

    return deal?.subcaption || 'Get 10% off your Osmosis Plan subscription.';
  };

  const getDisclaimer = () => {
    if (schoolData) {
      const expires = moment().endOf('month').format('MMMM Do, YYYY');
      return `Offer ends ${expires} and is applicable to students at ${schoolData.name} only. Offer cannot be combined with any other promotion or discount.`;
    }
    if (isUserDeal && dealPaused)
      return 'Offer cannot be combined with any other promotion or discount.';
    return deal?.disclaimer || 'Offer expires ' + deal?.expires + '.';
  };

  const caption = getCaption(!!isUserDeal, friendName, schoolData, deal);
  const subcaption = getSubcaption();
  const disclaimer = getDisclaimer();

  const openSubBanner = () => {
    setSubBanner(!subBanner);
  };

  return (
    <Flex
      className={`bg-wp-red m-4 mx-10 mb-8 w-11/12 max-w-full flex-col justify-center rounded-lg p-6`}
    >
      <H2 className={`${text0} font-national-2 max-w-full font-bold`}>
        {caption}
      </H2>
      <Box className={`relative flex max-w-full justify-center`}>
        <P className={`${text0} font-national-2 ml-3 inline-block text-base`}>
          {subcaption}
        </P>
        <Box className={`relative inline-block opacity-90`}>
          <Box className="opacity-80 hover:cursor-pointer hover:opacity-100">
            <Icon
              data-testid="active-deal-banner-icon"
              icon={faInfoCircle}
              onClick={openSubBanner}
              className={`${text0} ml-1 text-opacity-90`}
            />
          </Box>
          {subBanner && <Tooltip content={disclaimer} />}
        </Box>
      </Box>
    </Flex>
  );
};
export default ActiveDealBanner;
